import { MenuItem, Select } from "@mui/material";
import budgetService from "api/budgetService";
import styles from "./styles.module.scss";

interface Props {
  value: number;
  onChange: (year: number) => void;
  className?: string;
}

/**
 * Wybór roku budżetowego. Lista lat pobierana z BE (/budget/years);
 * bieżąco wybrany rok jest zawsze dostępny na liście (nawet jeśli BE go nie zwróci).
 */
const BudgetYearSelect = ({ value, onChange, className }: Props) => {
  const { data: years = [] } = budgetService.useGetBudgetYears();

  const options = Array.from(new Set([...years, value])).sort((a, b) => a - b);

  return (
    <Select
      size="small"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={`${styles.select} ${className ?? ""}`}
    >
      {options.map((y) => (
        <MenuItem key={y} value={y}>
          Rok {y}
        </MenuItem>
      ))}
    </Select>
  );
};

export default BudgetYearSelect;
